// Author Liang Gang Qiang
// Date 2022-02-28 09:07:43

class SithMesPrdPpdScheduledResultItemPsri {
constructor({
        id = null,
        psriIdPdsr = '',
        psriIdPpd = '',
        ppdChineseDescription = '',
        psriFinishVariance = '',
        psriDurationVariance = '',
        psriReasonType = '',
        psriReason = '',
        psriDelivery = '',
        psriDeliveryDays = '',
        remark = ''}
= {}) {
    this.id = id;
    this.psriIdPdsr = psriIdPdsr;
    this.psriIdPpd = psriIdPpd;
    this.ppdChineseDescription = ppdChineseDescription;
    this.psriFinishVariance = psriFinishVariance;
    this.psriDurationVariance = psriDurationVariance;
    this.psriReasonType = psriReasonType;
    this.psriReason = psriReason;
    this.psriDelivery = psriDelivery;
    this.psriDeliveryDays = psriDeliveryDays;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpdScheduledResultItemPsri();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.network',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.wbsNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cid',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.cid',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omName',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.omName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppdActivityId',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.ppdActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriFinishVariance',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriFinishVariance',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriDurationVariance',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriDurationVariance',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriReasonTypeName',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriReasonTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriReason',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriReason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriDelivery',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriDelivery',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'psriDeliveryDays',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.psriDeliveryDays',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    psriIdPdsrFilter : '',
    pdsrIdIsNullFilter : '',
    psriIdPpdFilter : '',
    projectCodeFilter : '',
    wbsNumberFilter : '',
    cidFilter : '',
    omNameFilter : '',
    prpIdFilter : '',
    prpIdInFilter : [],
    psriFinishVarianceFilter : '',
    psriDurationVarianceFilter : '',
    psriReasonTypeFilter : '',
    psriReasonFilter : '',
    psriDeliveryFilter : '',
    psriDeliveryDaysFilter : '',
    createdByFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'psriIdPdsrFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriIdPdsr',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriIdPpdFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriIdPpd',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNumberFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.wbsNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cidFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.cid',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omNameFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.omName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriReasonTypeFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriReasonType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '设计' },
                { value: '2', text: '数据维护' },
                { value: '3', text: '采购' },
                { value: '4', text: '客户' },
                { value: '5', text: '计划' },
                { value: '6', text: '其他' }
            ]
        }
        },
        {
        key: 'psriReasonFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriReason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriDeliveryFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriDelivery',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriDeliveryDaysFilter',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.filter.psriDeliveryDays',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'psriIdPdsr',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.psriIdPdsr',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ppdChineseDescription',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.ppdChineseDescription',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriReasonType',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.psriReasonType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '设计' },
                { value: '2', text: '数据维护' },
                { value: '3', text: '采购' },
                { value: '4', text: '客户' },
                { value: '5', text: '计划' },
                { value: '6', text: '其他' }
            ]
        }
        },
        {
        key: 'psriReason',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.psriReason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriDelivery',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.psriDelivery',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'psriDeliveryDays',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.psriDeliveryDays',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpdScheduledResultItemPsri.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdPpdScheduledResultItemPsri, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
